/**
 * Bottom navigation bar rendered only on mobile (< lg).
 * Five key destinations with 44×44px minimum touch targets.
 */
import { useNavigate, useLocation } from 'react-router-dom'
import { Home, ListTodo, Folder, Bell, Settings } from 'lucide-react'

const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: Home, path: '/home' },
  { id: 'tasks', label: 'Tasks', icon: ListTodo, path: '/task' },
  { id: 'projects', label: 'Projects', icon: Folder, path: '/project' },
  { id: 'notifications', label: 'Alerts', icon: Bell, path: '/settings' },
  { id: 'settings', label: 'Settings', icon: Settings, path: '/settings' },
]

export function MobileBottomNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isActive = (path: string) => {
    if (pathname === path) return true
    if (path !== '/' && pathname.startsWith(path + '/')) return true
    return false
  }

  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#1a2942] border-t border-[#3D4F61] flex lg:hidden"
    >
      {NAV_ITEMS.map(({ id, label, icon: Icon, path }) => {
        const active = isActive(path)
        return (
          <button
            key={id}
            onClick={() => navigate(path)}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#DAA520] ${
              active ? 'text-[#DAA520]' : 'text-[#A3B1BF] hover:text-white'
            }`}
          >
            <Icon className="size-5 shrink-0" aria-hidden />
            <span className="text-[10px] leading-none">{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
